import {
  GlobalDialogStateProps,
  GlobalDialogActionTypes,
  Props,
} from "../../../utils/types/redux/globalDialog";

// ACTION TYPES

const SET_PROPS = "globalDialog/SET_PROPS";

// REDUCER

const initialState: GlobalDialogStateProps = {
  props: { open: false },
};

const reducer = (
  state = initialState,
  action: GlobalDialogActionTypes,
): GlobalDialogStateProps => {
  switch (action.type) {
    case SET_PROPS:
      return {
        ...state,
        props: action.payload,
      };

    default:
      return state;
  }
};

export default reducer;

// ACTION CREATORS

export const setProps = ({
  open = true,
  ...args
}: Props): GlobalDialogActionTypes => ({
  type: SET_PROPS,
  payload: { open: open || false, ...args },
});
